import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../../firebase";

export default function AttendeeList({ attendeeIds = [], isAttending }) {
	const [attendees, setAttendees] = useState([]);
	const navigate = useNavigate();
	const { eventId } = useParams();

	useEffect(() => {
		if (!attendeeIds.length) return;

		const fetchAttendees = async () => {
			try {
				const promises = attendeeIds.slice(0, 7).map(async (uid) => {
					const userRef = doc(db, "users", uid);
					const userSnap = await getDoc(userRef);
					if (userSnap.exists()) {
						return { uid, ...userSnap.data() };
					}
					return null;
				});

				const users = await Promise.all(promises);
				setAttendees(users.filter(Boolean));
			} catch (error) {
				console.error("Error fetching attendees:", error);
			}
		};

		fetchAttendees();
	}, [attendeeIds]);

	const handleClick = (e) => {
		e.stopPropagation();
		e.preventDefault();
		if (isAttending) {
			navigate(`/event/${eventId}/attendees`);
		} else {
			alert("You need to RSVP to this event to view attendees.");
		}
	};

	return (
		<Card
			className="mt-2"
			onClick={handleClick}
			style={{ cursor: isAttending ? "pointer" : "not-allowed", borderColor: "primary" }}
		>
			<Card.Body>
				<div>
					<i className="bi bi bi-arrow-through-heart-fill me-2 my-color"></i>
					View attendees ({attendeeIds.length}) and start <span className="text-primary">matching!</span>
				</div>

				<div className="d-flex mt-2 align-items-center flex-wrap">
					{attendees.map((user) => (
						<div
							key={user.uid}
							className="rounded-circle overflow-hidden me-1 attendee-list circles-att"
							title={user.displayName || "User"}
						>
							<img
								src={user.photoURL || "/images/no-profile-picture.png"}
								alt={user.displayName || "User"}
								style={{ width: "100%", height: "100%", objectFit: "cover" }}
							/>
						</div>
					))}
					{attendeeIds.length > 7 && (
						<span
							className="ms-1 mt-1 text-decoration-underline text-primary"
							style={{ fontSize: "13px", cursor: "pointer" }}
						>
							+{attendeeIds.length - 7} more
						</span>
					)}
				</div>

				{!isAttending && (
					<small className="text-muted mt-2 d-block">
						<i className="bi bi-lock me-1"></i>RSVP to view and match with attendees
					</small>
				)}
			</Card.Body>
		</Card>
	);
}
